import { CalendarDesktop } from './CalendarDesktop';
import { CalendarMobile } from './CalendarMobile';
import type { CalendarViewEvent, ColourKeyItem } from 'gossamer-front-end';
import type { BookingExtendedViewRow } from 'cb-model';
import { useIsMobile } from '../event/hooks/useIsMobile';
import type { WebsiteEventFilterValues } from '../website-events/WebsiteEventFilters';

export interface UserBookingCalendarEvent extends CalendarViewEvent {
  colorCode: string;
  booking?: BookingExtendedViewRow;
}

export const EVENT_TYPE_COLORS: Record<string, string> = {
  public: '#15803D',
  'private-institution': '#2563EB',
  'private-group': '#F59E0B',
  booking: '#7F1D1D',
};

export const EVENT_TYPE_LEGEND: ColourKeyItem[] = [
  { id: 'public', label: 'Public', bgColor: EVENT_TYPE_COLORS.public },
  { id: 'private-institution', label: 'Private (My Institution)', bgColor: EVENT_TYPE_COLORS['private-institution'] },
  { id: 'private-group', label: 'Private (My Group(s))', bgColor: EVENT_TYPE_COLORS['private-group'] },
  { id: 'booking', label: 'My Bookings', bgColor: EVENT_TYPE_COLORS.booking },
];

export interface CalendarCombinedProps {
  institutionId: number;
  eventFilters: WebsiteEventFilterValues;
}

export const CalendarCombined = (props: CalendarCombinedProps): React.JSX.Element => {
  const isMobile = useIsMobile(992); // Bootstrap's `lg` breakpoint
  return isMobile ? (
    <CalendarMobile institutionId={props.institutionId} eventFilters={props.eventFilters} />
  ) : (
    <CalendarDesktop institutionId={props.institutionId} eventFilters={props.eventFilters} />
  );
};
